import { render, staticRenderFns } from "./im-search-history.vue?vue&type=template&id=5282cae9"
import script from "./im-search-history.vue?vue&type=script&lang=js"
export * from "./im-search-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5282cae9')) {
      api.createRecord('5282cae9', component.options)
    } else {
      api.reload('5282cae9', component.options)
    }
    module.hot.accept("./im-search-history.vue?vue&type=template&id=5282cae9", function () {
      api.rerender('5282cae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-search-history.vue"
export default component.exports